import { Component, Input } from '@angular/core';
import { ProductDetail } from '../../generic/classes/product.detail';

@Component({
    selector: 'product-detail-labels',
    templateUrl: 'productdetail.labels.component.html',
    styleUrls: ['productdetail.labels.component.scss'],
    standalone: true,
})
export class ProductDetailLabelsComponent {
    @Input() productDetail: ProductDetail;

    isNew(): boolean {
        const featuresArray = this.getFeatures();
        return featuresArray.indexOf('Brand New') > -1;
    }

    getFeatures(): string[] {
        const features: string[] = [];

        if (this.productDetail.features) {
            const featuresArray = this.productDetail.features.split(',');

            featuresArray.forEach(feature => {
                const trimmedFeature = feature.trim();
                features.push(trimmedFeature);
            });
        }

        return features;
    }

    showLabels(): boolean {
        return (
            this.isNew() ||
            this.productDetail.brandingDescription.length > 0 ||
            this.productDetail.vendorIsAuction
        );
    }
}
